import { useLocation } from 'react-router-dom'

import { isFullBleedPath } from '../../Services/layoutConfig'

/**
 * Contenitore principale delle pagine autenticate, con supporto layout full-bleed.
 * @param {Object} props
 * @param {import('react').ReactNode} props.children - Contenuto della pagina
 * @returns {JSX.Element}
 */
export const PageContainer = ({ children }) => {
  const { pathname } = useLocation()
  const flush = isFullBleedPath(pathname)

  return (
    <main
      className={['nora-shell-v2__main', flush ? 'nora-shell-v2__main--flush' : '']
        .filter(Boolean)
        .join(' ')}
    >
      <div className={['nora-page', flush ? 'nora-page--flush' : ''].filter(Boolean).join(' ')}>
        {children}
      </div>
    </main>
  )
}
